<template>
  <div class="custom-upload">
      <!-- 多张 -->
      <template v-if="multiple">
        <draggable :list="value" class="drag-group" :options="drawOptions">
          <template v-for="(item, index) of value">
            <item 
            :videoBarRander="videoBarRander"
              :key="index"
              v-bind="item"
              :source-actions="sourceActions"
              :type="type"
              :disabled="disabled"
              @preview="onPreviewClick(item, index, $event)"
              @delete="onDeleteClick(item, index, $event)"
            />
          </template>

        <item
        :videoBarRander="videoBarRander"
          :empty-actions="emptyActions"
          :type="type"
          :multiple="multiple"
          :disabled="disabled"
          @upload="onUploadSources"
          @capture="captureVisible = true"
          @link="linkVisible = true"
        />
        </draggable>
      </template>

      <!-- 单张 -->
      <template v-else>
        <item
        :videoBarRander="videoBarRander"
          v-bind="value[0] || {}"
          :type="type"
          :multiple="multiple"
          :disabled="disabled"
          :source-actions="sourceActions"
          :empty-actions="emptyActions"
          @upload="onUploadSources"
          @capture="captureVisible = true"
          @link="linkVisible = true"
          @preview="onPreviewClick()"
          @delete="onDeleteClick"
        />
      </template>
    
    <capture-dialog v-model="captureVisible" :choices="choices" @submit="onAddCaptureSources" :multiple="multiple" :modal="childModal"/>
    <link-dialog v-model="linkVisible" :type="type" @submit="onAddLinkSources" :multiple="multiple" :modal="childModal"/>
    <!-- <preview-dialog v-model="previewVisible"></preview-dialog> -->
  </div>
</template>

<script>
import Item from './item'
import CaptureDialog from './components/CaptureDialog'
import LinkDialog from './components/LinkDialog'
// import PreviewDialog from './components/PreviewDialog'
import typeMixin from './mixins/type'
import draggable from 'vuedraggable'

export default {
  name: 'CustomUpload',
  mixins: [ typeMixin ],
  components: {
    Item,
    CaptureDialog,
    LinkDialog,
    draggable,
    // PreviewDialog
  },
  model: {
    prop: 'value',
    event: 'change',
  },
  props: {
    // v-model，传入一个数组，图片列表 [ { src: '' } ]
    value: { type: Array, default: () => [] },

    // 抓取图片的数据列表，格式和value一致
    choices: { type: Array, default: () => [] },

    // 没有添加内容时，触发添加的操作方式
    // upload:上传；capture:抓取（要传choices）；link:填写链接
    emptyActions: { type: Array, default: () => [ 'upload', 'capture', 'link' ] },

    // 有内容时，堆内容的操作方式
    // preview:预览；delete:删除
    sourceActions: { type: Array, default: () => [ 'preview', 'delete' ] },

    // 多张图片
    multiple: { type: Boolean, default: false },

    // 是否可以拖拽
    draw: Boolean,

    // 弹框的modal
    childModal: { type: Boolean, default: true },

    disabled: Boolean,

    
  },
  data: () => ({
    videoBarRander:true,
    captureVisible: false,
    linkVisible: false,
    // previewVisible: false,
  }),
  computed: {
    drawOptions: (vm) => ({
      group: '.upload-item',
      filter: '.upload-item.is-empty',
      sort: vm.draw,
    }),
  },


  methods: {

    // 上传图片
    onUploadSources(images) {
      images = images.map((src) => ({ src }))
      this.onAddLinkSources(images)
    },

    // 抓取图片
    onAddCaptureSources(images) {
      images = images.map(({ src }) => ({ src }))
      this.onAddLinkSources(images)
    },

    // 填写图片链接
    onAddLinkSources(images) {
      images = this.value.concat(images)
      this.$emit('change', images)
    },

    // 点击预览
    onPreviewClick(item) {
      if (!this.multiple) item = this.value[0]
      window.open(item.src)
      // this.previewVisible = true
    },

    // 点击删除
    onDeleteClick(item, index) {
      this.videoBarRander = false
      if (!this.multiple) return this.$emit('change', [])
      const value = this.value.filter((o, i) => i !== index)
      this.$emit('change', value)
      this.$nextTick(() => {
        this.videoBarRander = true
      })
    },
  },
}
</script>

<style lang="scss" scoped>
.drag-group {
  display: inline-block;
}
</style>